import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import connector from '../connector.js';
import actionContext from 'contexts/actions.js';
import ErrorBoundary from 'modules/errors/Boundary.js';
import UI from './@impl/index.jsx';

/*
import siteUI from './site/index.jsx';
import stvUI from './stv/index.jsx';
import mobileUI from './mobile/index.jsx';
*/


export default function AppConstructor(store, API) {
  const App = connector(UI);

  return {
    render(container) {
      const root = createRoot(container);

      root.render(
        <ErrorBoundary onError={API.panic}>
          <Provider store={store}>
            <actionContext.Provider value={API}>
              <App />
            </actionContext.Provider>
          </Provider>
        </ErrorBoundary>,
      );
    },
  };
}
